module.exports = __webpack_public_path__ + "img/flyer-1.85fbb5ae.jpeg";